import { CarFleetViewRecord, CarFleetViewScheduleRecord } from '@navio/nsdk';
import { getCarDisplayName } from 'noddi-util';
import { FleetSwapDialog, useAuthContext } from 'noddi-web';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';
import { getCommonTranslations } from '../../../utils/commonTranslations';
import { getErrorCodesWithTrans } from '../../../utils/getErrorCodesWithTranslations';

export type SwapTarget = {
  car: CarFleetViewRecord;
  fleetSchedule: CarFleetViewScheduleRecord;
};

type Props = {
  /** Enrolled car being replaced. `null` keeps the dialog closed. */
  target: SwapTarget | null;
  onClose: () => void;
  onSwapped?: () => void;
};

/** Customer entry to the shared swap dialog: scoped to the group's own fleet and brand. */
export const SwapFleetCarDialog = ({ target, onClose, onSwapped }: Props) => {
  const { currentUserGroupId } = useAuthContext();
  const { currentBrand, brandEmail } = useCurrentBrand();

  return (
    <FleetSwapDialog
      outgoing={
        target && {
          fleetScheduleVehicleId: target.fleetSchedule.fleetScheduleVehicleId,
          fleetScheduleId: target.fleetSchedule.fleetScheduleId,
          fleetScheduleName: target.fleetSchedule.fleetScheduleName,
          userGroupCarId: target.fleetSchedule.userGroupCarId,
          carId: target.car.id,
          licensePlateNumber: target.car.licensePlate.number,
          carDisplayName: getCarDisplayName({ car: target.car, showLicensePlate: false, showYear: false }) || null
        }
      }
      scope={{ kind: 'customer', userGroupId: currentUserGroupId!, brandDomain: currentBrand }}
      onClose={onClose}
      onSwapped={onSwapped}
      translations={getCommonTranslations().getFleetSwapTexts(brandEmail)}
      errorCodes={getErrorCodesWithTrans(brandEmail)}
    />
  );
};
